import http from "../services/httpService";
import { isEmpty } from "../utilities/globalUtil";
import { injectHtml } from "../utilities/htmlUtil";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
import initModalMap from "./modal-maps";

const ajaxTarget = $("#locationResults");
var youAreHere = {
  url: "/wp-content/themes/inspired-ttr/assets/svg/youAreHere.svg",
  scaledSize: new google.maps.Size(35, 55),
};
var geocoder,
  map,
  infoWindow,
  allowedBounds,
  locationsMarker,
  i,
  category,
  customerMarker = youAreHere;
var gmarkers = [];
async function initMainMap() {
  if (ajaxTarget) {
    initialiseMapEvents();
    await initlocationsMap();
  }
}

async function initlocationsMap() {
  allowedBounds = new google.maps.LatLngBounds();

  geocoder = new google.maps.Geocoder();
  var latlng = new google.maps.LatLng(55, -5);
  var mapOptions = {
    zoom: 6,
    minZoom: 5,
    center: latlng,
    mapTypeControl: false,
    fullscreenControl: false,
    region: "uk",
  };
  map = new google.maps.Map(
    document.getElementById("location-map"),
    mapOptions
  );
  infoWindow = new google.maps.InfoWindow();
  google.maps.event.addListenerOnce(map, "idle", function () {
    if (!isEmpty(document.getElementById("location").value)) {
      document.getElementById("submit").click();
    } else {
      // markers on load
      let sport = document.getElementById("sport");
      //console.log(sport.value);

      let formData = new FormData();

      formData.set("action", "load_locations");
      formData.set("nonce", Ajax.nonce);
      formData.set("sport", sport.value);

      const params = new URLSearchParams(formData);

      //console.log(formData);

      fetch(Ajax.ajaxurl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Cache-Control": "no-cache",
        },
        body: params,
      })
        .then((response) => {
          //console.log()
          return response.text();
        })
        .then((response) => {
          console.log(response);
          let res = JSON.parse(response);

          clearLocations();

          if (map) {
            createMainMarkers(res.data);
          }

          injectStockistInformation(res.data);

          initModalMap();

          var sw = new google.maps.LatLng(48.064192, -9.711914);
          var ne = new google.maps.LatLng(61.015725, 3.691406);

          var viewport = new google.maps.LatLngBounds(sw, ne);

          map.fitBounds(viewport);
          map.setCenter(viewport.getCenter());
          map.setZoom(6);
        })
        .catch((err) => {
          // There was an error
          return err;
        });
    }
  });
}

async function initialiseMapEvents() {
  let location = document.getElementById("locations");

  if (location != null) {
    location.addEventListener("submit", function (event) {
      if (event.defaultPrevented) {
        return;
      }
      geocodeAddress();

      event.preventDefault();
    });
  }
}

async function geocodeAddress() {
  var address = document.getElementById("location").value;
  address = address + ", UK";
  var distance = document.getElementById("distance").value;

  /*
	var gender = document.getElementById('gender').value;
	var surface = document.getElementById('surface').value;
	var standard = document.getElementById('standard').value;
	var days = document.getElementById('days').value;
	*/

  var sw = new google.maps.LatLng(50.064192, -9.711914);
  var ne = new google.maps.LatLng(61.015725, 3.691406);

  var viewport = new google.maps.LatLngBounds(sw, ne);

  var selectedFilters = document.querySelectorAll(".map_filters:checked");
  //console.log('selected: '+selectedFilters);
  var mapFilters = {};
  if (!isEmpty(selectedFilters)) {
    selectedFilters.forEach((el, index) => {
      mapFilters[index] = {};
      mapFilters[index][el.name] = el.value;
    });

    //console.log(mapFilters);
  }

  const filters = document.querySelectorAll(".form-filter");
  const filterForm = document.querySelector(".filter-form");

  geocoder.geocode(
    {
      address: address,
      region: "uk",
      bounds: viewport,
    },
    async function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        allowedBounds = new google.maps.LatLngBounds();

        var customLat = results[0].geometry.location.lat();
        var customLng = results[0].geometry.location.lng();

        //this.activeFilters = {};
        //this.selectedFilters = {};
        $(".inner-date-ul").on("click", function (e) {
          e.stopPropagation();
          //console.log('active');
        });
        //this.filter = this.filters.find('.data-filter');
        //this.subFilter = this.filter.find('.container-radio');

        var tags = [];
        $("#filters-checkbox").on(
          "change",
          "input[type=checkbox]",
          function () {
            var id = $(this).val();
            var index = tags.indexOf(id);

            if ($(this).is(":checked")) {
              tags.push(id);
              document.getElementById("tags").innerHTML =
                "<li>" + tags + "</li>";
            } else {
              if (index > -1) {
                tags.splice(index, 1);
                document.getElementById("tags").innerHTML =
                  "<li>" + tags + "</li>";
              }
            }
            //console.log(tags);
          }
        );

        var days = [];
        var gender = [];
        var standard = [];
        var surface = [];
        var season = [];
        let sport = document.getElementById("sport");

        function dayFilter() {
          let days = [];
          let daysCheckboxes = document.querySelectorAll(
            'input[name="days"]:checked'
          );

          daysCheckboxes.forEach((item) => {
            days.push(item.value);
          });

          //console.log(days);
          return days;
        }

        function standardFilter() {
          let standard = [];
          let standardCheckboxes = document.querySelectorAll(
            'input[name="standard"]:checked'
          );

          standardCheckboxes.forEach((item) => {
            standard.push(item.value);
          });

          //console.log(days);
          return standard;
        }

        function genderFilter() {
          let gender = [];
          let genderCheckboxes = document.querySelectorAll(
            'input[name="gender"]:checked'
          );

          genderCheckboxes.forEach((item) => {
            gender.push(item.value);
          });

          //console.log("gender: " + gender);
          return gender;
        }

        function surfaceFilter() {
          let surface = [];
          let surfaceCheckboxes = document.querySelectorAll(
            'input[name="surface"]:checked'
          );

          surfaceCheckboxes.forEach((item) => {
            surface.push(item.value);
          });

          //console.log("surface: " + surface);
          return surface;
        }

        function seasonFilter() {
          let season = [];
          let seasonCheckboxes = document.querySelectorAll(
            'input[name="season"]:checked'
          );

          seasonCheckboxes.forEach((item) => {
            season.push(item.value);
          });

          //console.log("season: " + season);
          return season;
        }

        days = dayFilter();
        standard = standardFilter();
        gender = genderFilter();
        surface = surfaceFilter();
        season = seasonFilter();

        //console.log("days: " + days);
        //console.log("standard: " + standard);
        //console.log("gender: " + gender);
        //console.log("surface: " + surface);

        allowedBounds.extend(new google.maps.LatLng(customLat, customLng));

        const data = {
          action: "locations",
          latitude: customLat,
          longitude: customLng,
          distance: distance,
          standard: standardFilter(),
          days: dayFilter(),
          league_class: genderFilter(),
          surface: surfaceFilter(),
          sport: sport.value,
          gender: gender,
          days: days,
          surface: surface,
          season: season,
          standard: standard,
        };

        if (!isEmpty(mapFilters)) {
          data["filters"] = mapFilters;
        }

        $("#loader").css("display", "flex").fadeIn();

        // get location search results
        const locationsResults = await getNearestlocations(data);

        if (locationsResults.total) {
          // if (customerMarker) {
          // 	customerMarker.setMap(null);
          // }

          clearLocations();

          await createMainMarkers(locationsResults);

          await injectStockistInformation(locationsResults);

          customerMarker = new google.maps.Marker({
            map: map,
            icon: youAreHere,
            position: results[0].geometry.location,
          });

          gmarkers.push(customerMarker);
        } else {
          clearLocations();
          await injectError("Your search did not return any results");
        }

        $("#loader").fadeOut();
      } else {
        if (status === "ZERO_RESULTS") {
          await injectError("Your search did not return any results");
          return;
        }
        alert("Geocode was not successful for the following reason: " + status);
      }
    }
  );
}

async function getNearestlocations(data) {
  //console.log(data);
  const response = await http.post("/wp-json/locations/results", data, "json");
  //console.log(response.data);
  return response.data;
}

$(".data-filter").on("click", function () {
  //$('.data-filter').removeClass('active');
  if ($(this).hasClass("active")) {
    $(".data-filter").removeClass("active");
  } else {
    $(".data-filter").removeClass("active");
    $(this).toggleClass("active");
  }
});

$(".find-a-league__search-container .search").on("click", function (e) {
  $(".data-filters").removeClass("active");
});

$(".data-filter a").on("click", function (e) {
  e.preventDefault();
  //$(this).toggleClass('active');
});

$("#filterMobile").on("click", function (e) {
  $("#filters-checkbox").toggleClass("active");
});

$('*[data-active-filter="clear"]').on("click", function (e) {
  $('input[type="checkbox"]').removeProp("checked");
  $("#submit").trigger("click");
});

$(document).on("click", ".filter-remove", function (e) {
  let filter = $(this).attr("data-filter");
  $("#" + filter).prop("checked", false);
  $(this).parent("span").remove();
  $("#submit").trigger("click");
});

$('.find-a-league__filters input[type="checkbox"]').on("change", function (e) {
  // if ($('input[type="checkbox"]').prop("checked")) {
  //   $(".active-filters").prepend(
  //     '<span class="active-filters__filter text-color-white mb-0 d-block" data-active-filter="clear"><a class="filter-remove"><svg width="16" height="16"><use href="#icon-filter-close" /></svg></a>Clear All</span>'
  //   );
  // }

  if (e.currentTarget.checked) {
    $(".active-filters").append(
      '<span class="active-filters__filter text-color-white mb-0 d-block" data-active-filter="' +
        e.currentTarget.id +
        '"><a class="filter-remove"  data-filter="' +
        e.currentTarget.id +
        '"><svg width="16" height="16"><use href="#icon-filter-close" /></svg></a>' +
        e.currentTarget.value +
        "</span>"
    );
    $("#submit").trigger("click");
  } else {
    $('*[data-active-filter="' + e.currentTarget.id + '"]').remove();
    $("#submit").trigger("click");
  }
});

$(".data-filter select").on("change", function () {
  $("#submit").trigger("click");
});

$(".data-filter").on("mouseaway", function () {
  $(this).removeClass("active");
});

$(".data-filter.active").on("mouseleave", function () {
  $(this).removeClass("active");
  $("#submit").trigger("click");
});

async function createMainMarkers(data) {
  $.map(data, function (item) {
    // Check if store has a lat and long
    if (item.venues) {
      let venues = item.venues;
      venues.forEach((venue) => {
        // Store has a lat and long, set locationsMarker
        setMarkers(
          item.sport,
          venue.latitude,
          venue.longitude,
          venue.ID,
          venue.post_title,
          venue.address,
          venue.distance
        );
      });
    }

    // Set Markers Function
    function setMarkers(
      sport,
      lat,
      lng,
      venue_id,
      venue_title,
      venue_address,
      distance
    ) {
      //console.log(sport);

      if (sport === "Referee Workshop") {
        // Set Markers
        var markerIcon = {
          url: "/wp-content/themes/inspired-ttr/assets/svg/map_marker_yellow.svg",
          scaledSize: new google.maps.Size(26, 35),
        };
      } else {
        // Set Markers
        var markerIcon = {
          url: "/wp-content/themes/inspired-ttr/assets/svg/map_marker.svg",
          scaledSize: new google.maps.Size(26, 35),
        };
      }

      // Adds new locationsMarker for each
      locationsMarker = new google.maps.Marker({
        map: map,
        icon: markerIcon,
        position: new google.maps.LatLng(lat, lng),
        venue_id: venue_id,
        league_id: item.league_id,
      });

      //console.log('cat: ' + category);

      locationsMarker.category =
        item.gender_tag +
        " " +
        item.surface_tag +
        " " +
        item.standard_tag +
        " " +
        item.days;
      gmarkers.push(locationsMarker);

      //console.log('cat: ' + locationsMarker.category);
      let popoverLink = "";
      if (item.sport == "Referee Workshop") {
        popoverLink =
          '<p class="mb-0" fs-14><a data-bs-toggle="modal" data-bs-target="#league_modal_' +
          item.league_id +
          '" style="cursor: pointer;">Venue Info</a></p>';
      } else {
        popoverLink =
          '<p class="mb-0" fs-14><a href="/?p=' +
          venue_id +
          '" style="cursor: pointer;">Venue Info</a></p>';
      }

      // Build info Window
      var iwContent =
        '<div id="venue_id_' +
        venue_id +
        '" class="marker" data-category="' +
        item.gender_tag +
        " " +
        item.surface_tag +
        " " +
        item.standard_tag +
        " " +
        item.days +
        '" data-lat="' +
        lat +
        '" data-lng="' +
        lng +
        '">' +
        '<p class="fs-18 fw-bold">' +
        venue_title +
        "</p>" +
        '<p class="fs-14">' +
        venue_address +
        "</p>" +
        '<p class="mb-0 fs-14"><strong>Distance: </strong>' +
        distance +
        "</p>" +
        popoverLink +
        "</div>";

      allowedBounds.extend(new google.maps.LatLng(lat, lng));

      //Links up the infoWindow on click event
      gmarkers.push(locationsMarker);

      google.maps.event.addListener(
        locationsMarker,
        "click",
        (function (locationsMarker, i) {
          return function () {
            infoWindow.setContent(iwContent);
            infoWindow.open(map, locationsMarker);
            highlightLeague(locationsMarker.league_id);
            updateLeagues(locationsMarker.venue_id);
          };
        })(locationsMarker, i)
      );
    }
  });

  if(map) map.fitBounds(allowedBounds);
  // document.getElementById('locationsResultList').scrollIntoView();
}

async function injectStockistInformation(data) {
  const result = data.html;

  await injectHtml("#locationsResultList", result);
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  // re initialise tooltips
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );
  // re initialise modal maps
  initModalMap();
}

async function updateLeagues(data) {
  const result = data.html;

  await injectHtml("#locationsResultList", result);
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );
  initModalMap();
}

async function highlightLeague(league_id) {
  //console.log("Highlight: league_" + league_id);
  let results = document.getElementById("locationsResultList");
  const highlighted = results.querySelector("#league_" + league_id);
  const leagues = results.querySelectorAll(".item-league-card");
  const realWidth = window.screen.width * window.devicePixelRatio;
  const realHeight = window.screen.height * window.devicePixelRatio;
  initModalMap();
  //console.log(results);
  leagues.forEach((league) => {
    //console.log(league.id);
    if (league.id == highlighted.id) {
      league.classList.add("highlighted");
      //console.log('Width ' + realWidth);
      //console.log('Height ' + realHeight);

      if (realWidth < 665) {
        let topPos = league.offsetTop - 650;
        results.scrollTop = topPos;
        //console.log(league.offsetTop);
        //console.log('smallest');
      } else if (realWidth < 805) {
        let topPos = league.offsetTop - 600;
        results.scrollTop = topPos;
        //console.log(league.offsetTop);
        //console.log('small');
      } else if (realWidth < 1060) {
        let topPos = league.offsetTop - 200;
        results.scrollTop = topPos;
        //console.log(league.offsetTop);
        //console.log('medium');
      } else {
        let topPos = league.offsetTop - 120;
        results.scrollTop = topPos;
        //console.log(league.offsetTop);
        //console.log('big');
      }
    } else {
      league.classList.remove("highlighted");
    }
  });
}

async function injectError(error) {
  const result = `<div class="alert alert-danger text-color-white fw-700 p-1" role="alert">
						${error}
					</div>`;
  await injectHtml("#locationsResultList", result);
}

function clearLocations() {
  if (infoWindow) infoWindow.close();

  if (map) {
    map.getStreetView().setVisible(false);

    var sw = new google.maps.LatLng(50.064192, -9.711914);
    var ne = new google.maps.LatLng(61.015725, 3.691406);

    var viewport = new google.maps.LatLngBounds(sw, ne);

    map.fitBounds(viewport);
    map.setCenter(viewport.getCenter());
    map.setZoom(6);

    // Remove markers from map and array
    for (var i = 0; i < gmarkers.length; i++) {
      gmarkers[i].setMap(null);
    }

    gmarkers.length = 0;
    gmarkers = [];
    customerMarker = null;
  }
}

$(function () {
  initMainMap();
  initModalMap();
});
